import {
  checklistTemplateKeys,
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export const useUpdateChecklistTemplateVersionApprovals = (
  options?: UseMutationOptions<
    string,
    RequestErrorType,
    RequestTypes['updateChecklistTemplateVersionApprovals']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.updateApprovals,
    ...options,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(
        checklistTemplateKeys.getVersion({
          templateId: variables.templateId,
          templateVersionId: variables.versionId,
        }).queryKey,
      )
    },
  })
}
